import { graphql } from 'react-relay';

export default graphql`
  query CorporatePage_Query {
    viewer {
      id
      ...CorporatePage_viewer
    }
  }
`;
